import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit, QueryList, SecurityContext, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxMasonryComponent } from 'ngx-masonry';
import { AppComponent } from '../app.component';
import { UrlService } from '../model/url.service';
import { GlobalService } from '../model/global.service';
import { SugarService } from '../model/sugar.service';
import { ComponentsService } from '../model/components.service';
import { MetaData } from '../shared/metadata/metadata.service';
import { ModalFormComponent } from '../modal-form/modal-form.component';
import { SocialShareComponent } from '../social-share/social-share.component';
import { UniversalPlatformService } from '../shared/platform/universal-platform.service';
import { ApiData } from '../shared/utils/api-data';
import { CollectionsPerPageService } from '../shared/collections/collections-per-page.service';
import { ExhibitionsColletionSetter } from '../shared/collections/api-collection-setters';
import * as imagesLoaded from 'imagesloaded';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';
import { getExpandText } from '../helpers/helpers';
import { getIndicesOf } from '../helpers/string-helpers';
var ExhibitionsComponent = /** @class */ (function () {
    function ExhibitionsComponent(urlService, domSanitizer, globalService, sugarService, componentsService, platformService, rootComp, metadata, perPageService) {
        var _this = this;
        this.urlService = urlService;
        this.domSanitizer = domSanitizer;
        this.globalService = globalService;
        this.sugarService = sugarService;
        this.componentsService = componentsService;
        this.platformService = platformService;
        this.rootComp = rootComp;
        this.metadata = metadata;
        this.perPageService = perPageService;
        this.isDescriptionExpanded = false;
        this.activeTextElementsOnHoverEnabled = false;
        this.activeTextElementsOnHoverEnabled = this.globalService.settings.global.activeTextElementsOnHoverEnabled === 'true';
        this.cutDescription = this.globalService.settings.global.cutDescriptions === 'true';
        this.cutDescriptionMaxLength = Number(this.globalService.settings.global.cutDescriptionMaxLength);
        if (isNaN(this.cutDescriptionMaxLength)) {
            this.cutDescriptionMaxLength = 400;
        }
        this.zoomImages = this.globalService.settings.global.sliderRotation === 'true';
        this.settings = {};
        this._preloadingImages = false;
        this.globalService.loadGlobalSettings().subscribe(function (settings) {
            if (settings.__loaded) {
                _this.isFourColumns = settings.global.isFourColumns;
            }
        });
    }
    Object.defineProperty(ExhibitionsComponent.prototype, "masonryItem", {
        set: function (items) {
            var _this = this;
            if (!this.masonryContainer) {
                return;
            }
            setTimeout(function () {
                var maxH = 0;
                items.forEach(function (item) {
                    if (item.nativeElement.offsetHeight > maxH) {
                        maxH = item.nativeElement.offsetHeight;
                    }
                });
                _this.masonryContainer._msnry.$element[0].style.minHeight = maxH + 'px';
            }, 1000);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExhibitionsComponent.prototype, "hasPagination", {
        get: function () {
            return this._currentExhibitions && (this._currentExhibitions || []).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExhibitionsComponent.prototype, "getExpandText", {
        get: function () {
            return getExpandText(this.isDescriptionExpanded);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExhibitionsComponent.prototype, "masonryContainer", {
        get: function () {
            return this._masonryContainer;
        },
        set: function (item) {
            this._masonryContainer = item;
        },
        enumerable: true,
        configurable: true
    });
    ExhibitionsComponent.prototype.description = function (currentExhibition) {
        var _this = this;
        var plain = (this.domSanitizer.sanitize(SecurityContext.HTML, currentExhibition.description_short[this.urlService.langCode])
            || '').trim();
        var spacesPositions = getIndicesOf(plain, ' ');
        this.cutDescriptionMaxLength = spacesPositions.filter(function (pos) { return pos >= _this.cutDescriptionMaxLength; })[0];
        this.cutDescription = this.cutDescription && (plain || []).length > this.cutDescriptionMaxLength;
        return this.cutDescription && !this.isDescriptionExpanded
            ? (plain.slice(0, this.cutDescriptionMaxLength)) + '...'
            : currentExhibition.description_short[this.urlService.langCode];
    };
    ExhibitionsComponent.prototype.toggleDescription = function () {
        this.isDescriptionExpanded = !this.isDescriptionExpanded;
    };
    ExhibitionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.rootComp.fbService.updateCommonOg();
        this.sugarService.setCollection('current-exhibitions', {
            sugarNode: 'exhibitions',
            parameters: {
                expand: 'images',
                // "filter[active]": '1',
                'filter[status][0]': 'exhibition_status_in_preparation',
                'filter[status][1]': 'exhibition_status_ongoing',
                sort: '-date_from',
                'per-page': 10,
            },
        });
        this.sugarService.setCollection('exhibitions-archive', {
            sugarNode: 'exhibitions',
            parameters: {
                expand: 'images',
                // "filter[active]": '1',
                'filter[status]': 'exhibition_status_completed',
                sort: '-date_from',
                'per-page': 10,
            },
            availableSorting: [
                { id: '-date_from', title: 'exhibitions.sort-date-latest' },
                { id: 'date_from', title: 'exhibitions.sort-date-oldest' },
                { id: 'name', title: 'exhibitions.sort-title-a-z' },
                { id: '-name', title: 'exhibitions.sort-title-z-a' },
            ],
        });
        var collectionSetter = new ExhibitionsColletionSetter(this.urlService, this.sugarService, this.platformService, this.globalService, this.domSanitizer);
        this._dataSub = this.sugarService.getData().subscribe(function (data) {
            if (data.collectionId === 'current-exhibitions') {
                var currentExhibitions = collectionSetter.setup(data.data, 'current-exhibitions');
                _this._imagesTypes = [];
                for (var i = 0; i < (currentExhibitions || []).length; ++i) {
                    _this._imagesTypes.push((typeof currentExhibitions[i].image));
                    if (0 === i) {
                        _this._recommendedObject = currentExhibitions[i];
                    }
                }
                _this._currentExhibitions = currentExhibitions;
            }
            if (data.collectionId === 'exhibitions-archive') {
                var archive = collectionSetter.setupArchive(data.data, 'exhibitions-archive');
                _this._archive = [];
                var images = [];
                var image = void 0;
                _this._preloadingImages = true;
                for (var a = 0; a < (archive || []).length; ++a) {
                    if (_this.platformService.isBrowser) {
                        if (archive[a].images && (archive[a].images || []).length) {
                            image = new Image();
                            image.src = archive[a].images[0] ? archive[a].images[0].thumbnails.medium.url : 'assets/images/placeholder-450x340.jpg';
                            images.push(image);
                        }
                    }
                    _this._archive.push(archive[a]);
                }
                if (_this.platformService.isBrowser) {
                    var imgLoaded = imagesLoaded(images);
                    // wszystkie załadowane
                    imgLoaded.on('done', function () {
                        _this._afterPreload();
                    });
                    // przynajmniej jeden zwrócił błąd
                    imgLoaded.on('fail', function () {
                        _this._afterPreload();
                    });
                }
                else {
                    _this._afterPreload();
                }
            }
        });
        this.sugarService.refreshData('exhibitions-archive');
        // metadata
        this._csSub = this.componentsService.getComponents().subscribe(function (apiData) {
            var data = new ApiData(apiData);
            if (!data.typeIs('exhibitions')) {
                return;
            }
            if (data.hasMainContents()) {
                _this.metadata.setCollectionPageMetaFromMainContents(data.main_contents);
            }
            if (data.hasMainblock()) {
                _this.settings.items_per_page = parseInt(data.mainblock.items_per_page, 10);
                _this.settings.items_per_page_change_enabled = parseInt(data.mainblock.items_per_page_change_enabled, 10) > 0;
                _this.perPageService.setDefault('current-exhibitions', _this.settings.items_per_page);
                _this.perPageService.setSaving('current-exhibitions', _this.settings.items_per_page_change_enabled);
                _this.sugarService.updateParam('current-exhibitions', 'per-page', '' + (_this.perPageService.getValue('current-exhibitions')
                    ? _this.perPageService.getValue('current-exhibitions')
                    : _this.settings.items_per_page) + '');
                _this.perPageService.setDefault('exhibitions-archive', _this.settings.items_per_page);
                _this.perPageService.setSaving('exhibitions-archive', _this.settings.items_per_page_change_enabled);
                _this.sugarService.updateParam('exhibitions-archive', 'per-page', '' + (_this.perPageService.getValue('current-exhibitions')
                    ? _this.perPageService.getValue('current-exhibitions')
                    : _this.settings.items_per_page) + '');
            }
            _this.sugarService.refreshData('current-exhibitions');
            _this.sugarService.refreshData('exhibitions-archive');
        });
    };
    ExhibitionsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.rootComp.bodyClass = 'exhibitions';
        });
    };
    ExhibitionsComponent.prototype.ngOnDestroy = function () {
        this._csSub.unsubscribe();
        this._dataSub.unsubscribe();
    };
    ExhibitionsComponent.prototype.openRecommendationModal = function (index, evt) {
        var _this = this;
        this._recommendedObject = this._currentExhibitions[index];
        if (evt && typeof evt.prefentDefault !== 'undefined') {
            evt.preventDefault();
        }
        setTimeout(function () {
            _this.recommendationModal.openModal();
        }, 100);
    };
    ExhibitionsComponent.prototype.showPreloader = function () {
        if (!this._currentExhibitions) {
            return true;
        }
        return this._preloadingImages;
    };
    ExhibitionsComponent.prototype._afterPreload = function () {
        var _this = this;
        this._preloadingImages = false;
        if (this.platformService.isBrowser && this.masonry) {
            setTimeout(function () { return _this.masonry.layout(); }, 100);
        }
    };
    ExhibitionsComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [UrlService,
            DomSanitizer,
            GlobalService,
            SugarService,
            ComponentsService,
            UniversalPlatformService,
            AppComponent,
            MetaData,
            CollectionsPerPageService])
    ], ExhibitionsComponent);
    return ExhibitionsComponent;
}());
export { ExhibitionsComponent };
